module.exports = __webpack_public_path__ + "img/ico-scheduled.ed4823d5.svg";